<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增问答规则</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">提示：</div>
                <div class="right">
                    <p>1.问答规则中可调用的标签及标签规则，可下载<a :href="modelDownload" class="">“话题建模标签表”</a> 查看</p>
                </div>
            </div>
            <el-form class="form-container" :rules="rules" :model="formData" ref="singleAsksForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">话题名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="topic_id">
                            <el-select v-model="formData.topic_id" filterable placeholder="请选择">
                                <el-option
                                v-for="item in topicList"
                                :key="item.value"
                                :label="item.topic_name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-card class="box-card" v-for="(target,index) in formData.asks" :key="index">
                    <i class="el-icon-close" @click.prevent="removeContent(target)"></i>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">问题规则：</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                :prop="'asks.'+index+'.ask_name'" 
                                :rules="askRule"
                            >
                                <el-input placeholder="请输入问题规则" class="input-control" v-model="target.ask_name"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item" v-for="(item,key) in target.answer_name" :key="key">
                        <div class="form-label">
                            <span class="label">{{key > 0 ? '回答规则'+parseInt(key+1)+'：': '回答规则:'}} </span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                :prop="'asks.'+index+'.answer_name.'+key" 
                                :rules="awnRule"
                            >
                                <el-input type="textarea" placeholder="请输入回答规则" class="input-control" v-model="target.answer_name[key]"></el-input>
                            </el-form-item>                            
                        </div>
                        <div v-if="key == target.answer_name.length-1">
                            <el-button v-if="key<4" style="margin-left:10px" icon="el-icon-plus" circle @click="addAswInput(target.answer_name)"></el-button>
                            <el-button v-if="key>0" style="margin-left:10px" icon="el-icon-minus" circle @click="subAswInput(target.answer_name)"></el-button>
                        </div>
                    </div>
                </el-card>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button v-if="formData.asks.length < 10" @click="addCard">新增选项</el-button>
                    <el-button type="primary" @click="submitForm('singleAsksForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import {getBanklList,addSingleAsks} from '@/service/topicBank'

export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        return {
            formData:{
                topic_id:'',
                asks:[
                    {
                        ask_name:"",
                        answer_name:[""]
                    }
                ],
            },
            rules: {
                topic_id: [
                    { required: true, message: '请输入话题关键词', trigger: 'blur' },
                ],
               
            },
            askRule: [
                { required: true, message: '问题规则不能为空', trigger: 'blur' },
                { min: 1, max:50, message: '问题规则为1-50个字符之间', trigger: 'blur' },
            ],
            awnRule: [
                { required: true, message: '回答规则不能为空', trigger: 'blur' },
                { min: 1, max:999, message: '回答规则为1-999个字符之间', trigger: 'blur' },
            ],
            modelDownload:"",
            topicList:[],
        }
    },
    watch: {
    },

    mounted(){
        this.initData()
        const domain=document.domain;
        const host = window.serverConfig[window.siteMap[domain]].VUE_APP_FRIEND_LINK_URL;
        this.modelDownload = host+'话题建模规则-调用标签.xlsx';
    },
    methods: {
        initData(){
            getBanklList({
                per_page: 999,
                page: 1
            }).then(res => {
                this.topicList = res.data
            })
        },
        /** 打开右侧悬浮层 */
        openMenu (id) {
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.singleAsksForm && this.$refs.singleAsksForm.clearValidate()
        },
        resetForm () {
            this.formData = {
                topic_id:'',
                asks:[
                    {
                        ask_name:"",
                        answer_name:[""]
                    }
                ],
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    addSingleAsks(this.formData).then((data) => {
                        this.$message({
                            message: '添加成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '添加失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
        removeContent(item){
            const index = this.formData['asks'].indexOf(item)
            if (index !== -1) {
                this.formData['asks'].splice(index, 1)
            }
        },
        addCard(){
            this.formData.asks.push({
                ask_name:"",
                answer_name:[""]
            })
        },
        addAswInput(list){
            list.push("")
        },
        subAswInput(list){
            list.pop()
        }

    }
}
</script>
<style scoped>
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 20%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 50%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
.tips-wrapper .right a{
    text-decoration: none;
    color: #409EFF;
}
</style>